class AuthorizationService
{
    #storageKey;

    constructor() {
        this.#storageKey = "permissions";
    }

    can(action) {
        const permissions = JSON.parse(sessionStorage.getItem(this.#storageKey)) || [];

        return permissions.find(permission => permission.section === action) !== undefined;
    }

    cannot(action) {
        return !this.can(action);
    }
}

export default AuthorizationService;